import {RoutingNames} from "./routing-names.model";

export class WntRoutingNames extends RoutingNames {
  static institutions = 'instellingen';
  static accountabilityList = 'verantwoordingen';
  static wntSummary = 'wnt-overzicht';
  static publicationDate = 'publicatiedatum';
  static notes = 'notities';
  static legalBasis = 'grondslag';
  static submit = 'indienen';
  static registerExemption = 'registreer-vrijstelling';
  static revokeExemption = 'vrijstelling-intrekken';
  static requestDeregistration = 'aanvragen-afmelding';
  static publicInstitutions = 'publieke-instellingen';
  static publicInstitution = 'publieke-instelling';
  static editing = 'bewerken';
  static creating = 'aanmaken';
  static settings = 'aanpassen-bruto-loonsom';
  static usersOverview = 'gebruikers';
  static emailVerification = 'email-verificatie';
}
